"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M11.526 1.405a.5.5 0 01.948 0l2.244 6.658a.5.5 0 00.474.34h7.222a.5.5 0 01.287.91l-5.81 4.07a.5.5 0 00-.188.568l2.227 6.607a.5.5 0 01-.76.569l-5.883-4.12a.5.5 0 00-.574 0l-5.883 4.12a.5.5 0 01-.76-.57l2.227-6.606a.5.5 0 00-.187-.569l-5.811-4.07a.5.5 0 01.287-.909h7.222a.5.5 0 00.474-.34l2.244-6.658z" }), "Star");
//# sourceMappingURL=Star.js.map